import React, { Fragment } from "react";
import SettingsGeneralFormik from "./SettingsGeneralFormik";
import SettingsGeneralFormView from "./SettingsGeneralFormView";
import dynamic from "next/dynamic";
import Api from "src/data/api";
import { useSelector } from "react-redux";
import { GoogleLogin } from "react-google-login";
import WidgetImageUploadForm from "src/components/RetailerWidgetSettings/WidgetImageUploadForm";

// const DynamicEditor = dynamic(() => import("../../Editor"), {
//     ssr: false,
// });

const SettingsGeneral = ({
    generalSettings,
    isShopify,
    setRefetch,
    shouldHaveAllLocationsActive,
    widgetImg
}) => {
    const user = useSelector((store) => store.user.data);


    const handleGoogleAuthCode = async ({ code }) => {
        try {
            await Api.request({
                method: "POST",
                url: `/settings/gcal_oauth2`,
                data: {
                    code,
                },
            });
        } catch (err) {
            console.error(err);
        }
    };

    const handleGoogleError = (response) => {
        console.log(response);
    };

    return (
        <Fragment>
            <SettingsGeneralFormik
                generalSettings={generalSettings}
                isShopify={isShopify}
                setRefetch={setRefetch}
            >
                {(props) => (
                    <SettingsGeneralFormView
                        {...props}
                        isShopify={isShopify}
                        shouldHaveAllLocationsActive={
                            shouldHaveAllLocationsActive
                        }
                    />
                )}
            </SettingsGeneralFormik>
            <WidgetImageUploadForm widgetImg={widgetImg} />
            {user.role === "admin" && (
                <section>
                    <h2>Google Calendar Authorization</h2>
                    <p>
                        To create calendar events, the Tote dashboard needs an
                        admin's Google login to manage their calendar on their
                        behalf.
                        <br />
                        <strong>If you change the account used,</strong> the
                        dashboard won't be able to update or cancel calendar
                        events associated with existing events.
                    </p>

                    <GoogleLogin
                        clientId={CONFIG.google.clientId}
                        buttonText="Login with Google"
                        hostedDomain="bookwithtote.com"
                        scope="https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events"
                        responseType="code"
                        accessType="offline"
                        redirectUri="postmessage"
                        fetchBasicProfile={false}
                        prompt="consent"
                        onSuccess={handleGoogleAuthCode}
                        onFailure={handleGoogleError}
                        cookiePolicy={"single_host_origin"}
                    />
                </section>
            )}
        </Fragment>
    );
};

export default SettingsGeneral;
